import React from 'react';
import './cta.css';

const CTA = () => (
<div className="gpt3__cta">
    <div className="gpt3__cta-content">
        <p>We're committed to creating the best possible experience for our users.</p>
    <h3>We Value Your Feedback</h3>
    </div>
    <div className="gpt3__cta-btn">
        <button type="button">Give Feedback</button>
    </div>
</div>
);

export default CTA;